import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { expenseRepository as defaultExpenseRepository, type ExpenseRepository } from '@/infrastructure/firebase/expenseRepository';
import { receiptAiGateway as defaultReceiptAiGateway, type ReceiptAiGateway } from '@/infrastructure/firebase/receiptAiGateway';
import { profileRepository as defaultProfileRepository, type ProfileRepository } from '@/infrastructure/firebase/profileRepository';

interface RepositoryContextType {
  expenseRepository: ExpenseRepository;
  receiptAiGateway: ReceiptAiGateway;
  profileRepository: ProfileRepository;
}

export interface RepositoryProviderProps {
  children: ReactNode;
  expenseRepository?: ExpenseRepository;
  receiptAiGateway?: ReceiptAiGateway;
  profileRepository?: ProfileRepository;
}

const RepositoryContext = createContext<RepositoryContextType>({
  expenseRepository: defaultExpenseRepository,
  receiptAiGateway: defaultReceiptAiGateway,
  profileRepository: defaultProfileRepository,
});

// eslint-disable-next-line react-refresh/only-export-components
export const useRepositories = () => useContext(RepositoryContext);

export function RepositoryProvider({
  children,
  expenseRepository = defaultExpenseRepository,
  receiptAiGateway = defaultReceiptAiGateway,
  profileRepository = defaultProfileRepository,
}: RepositoryProviderProps) {
  return (
    <RepositoryContext.Provider value={{ expenseRepository, receiptAiGateway, profileRepository }}>
      {children}
    </RepositoryContext.Provider>
  );
}
